import { Alert, Box } from "@mui/material";

const VALID_TYPES = ["info", "success", "warning", "error"];

/**
 * Renders server-side flash messages passed as a { type: message } object.
 * Port of FlashAlert.vue.
 */
export default function FlashAlert({ flash }) {
    if (!flash || Object.keys(flash).length === 0) return null;

    return (
        <Box sx={{ mb: 2 }}>
            {Object.entries(flash).map(([key, message]) => (
                <Alert
                    key={key}
                    severity={VALID_TYPES.includes(key) ? key : "info"}
                    variant="outlined"
                    sx={{ mb: 1 }}
                >
                    <span dangerouslySetInnerHTML={{ __html: message }} />
                </Alert>
            ))}
        </Box>
    );
}
